import Vue from 'vue'

import { Button, Field, Toast, ActionSheet, Notify, Form, CellGroup, Popup, DatetimePicker, Loading, Overlay,Picker,Icon ,Cascader,Calendar   } from 'vant'

Vue.use(Button)
  .use(Field)
  .use(Toast)
  .use(ActionSheet)
  .use(Notify)
  .use(Form)
  .use(CellGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Loading)
  .use(Overlay)
  .use(Picker)
  .use(Icon)
  .use(Cascader)
  .use(Calendar)



// WEBPACK FOOTER //
// ./src/unit/vant.js